import api from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../yoshi-style-dependencies/css-loader.js??ruleSet[1].rules[2].rules[1].oneOf[0]!../yoshi-style-dependencies/postcss-loader.js??ruleSet[1].rules[2].rules[2]!./styles.global.css";

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



export default content.locals || {};